var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings3HalfstarRgb = function SvgTrustpilotRatings3HalfstarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 91 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3halfstar-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.957.023H18v16.801H.957Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3halfstar-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 .023h17v16.801H19Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3halfstar-RGB_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 .023h18v16.801H37Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3halfstar-RGB_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 .023h18v16.801H55Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3halfstar-RGB_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 .023h9v16.801h-9Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_3halfstar-RGB_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 .023h17.363v16.801H73Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3halfstar-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M17.723.023H.957v16.801h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3halfstar-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M35.883.023H19.117v16.801h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3halfstar-RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M54.043.023H37.277v16.801h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3halfstar-RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M72.203.023H55.437v16.801h16.766Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3halfstar-RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M63.82.023h-8.383v16.801h8.383Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_3halfstar-RGB_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M90.363.023H73.598v16.801h16.765Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.34 11.348 2.55-.649 1.063 3.29Zm5.867-4.254h-4.488l-1.38-4.235-1.378 4.235H3.473l3.632 2.625-1.378 4.234 3.632-2.625 2.235-1.61ZM27.5 11.348l2.55-.649 1.063 3.29Zm5.867-4.254H28.88L27.5 2.859l-1.379 4.235h-4.488l3.633 2.625-1.38 4.234 3.634-2.625 2.234-1.61ZM45.66 11.348l2.55-.649 1.063 3.29Zm5.867-4.254H47.04L45.66 2.859l-1.379 4.235h-4.488l3.633 2.625-1.38 4.234 3.634-2.625 2.234-1.61ZM63.82 11.348l2.551-.649 1.063 3.29Zm5.867-4.254H65.2L63.82 2.859l-1.379 4.235h-4.488l3.633 2.625-1.379 4.234 3.633-2.625 2.234-1.61ZM81.98 11.348l2.551-.649 1.063 3.29Zm5.868-4.254h-4.489L81.98 2.859l-1.378 4.235h-4.489l3.633 2.625-1.379 4.234L82 11.328l2.234-1.61Zm0 0"
  }));
};
export default SvgTrustpilotRatings3HalfstarRgb;